module.exports = __webpack_public_path__ + "static/media/kid-2.8a01b8d9.png";